/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetChartSourcesListQueryVariables = Types.Exact<{
  input: Types.InputMaybe<Types.FilterFactSource>;
}>;


export type GetChartSourcesListQuery = { __typename: 'Query', getFactSourceItems: { __typename: 'SourceItemResponse', total: number | null, items: Array<{ __typename: 'SourceItem', chart: string | null, chart_id: string | null, configuration: string | null, country_code: string | null, cycle: string | null, release_info: string | null, import_limit: number | null, visible: boolean | null, category: string | null, gfk_id: number | null, import_date_offset: number | null }> } };


export const GetChartSourcesListDocument = gql`
    query getChartSourcesList($input: FilterFactSource) {
  getFactSourceItems(input: $input) {
    items {
      chart
      chart_id
      configuration
      country_code
      cycle
      release_info
      import_limit
      visible
      category
      gfk_id
      import_date_offset
    }
    total
  }
}
    `;

/**
 * __useGetChartSourcesListQuery__
 *
 * To run a query within a React component, call `useGetChartSourcesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChartSourcesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChartSourcesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetChartSourcesListQuery(baseOptions?: Apollo.QueryHookOptions<GetChartSourcesListQuery, GetChartSourcesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChartSourcesListQuery, GetChartSourcesListQueryVariables>(GetChartSourcesListDocument, options);
      }
export function useGetChartSourcesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChartSourcesListQuery, GetChartSourcesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChartSourcesListQuery, GetChartSourcesListQueryVariables>(GetChartSourcesListDocument, options);
        }
export type GetChartSourcesListQueryHookResult = ReturnType<typeof useGetChartSourcesListQuery>;
export type GetChartSourcesListLazyQueryHookResult = ReturnType<typeof useGetChartSourcesListLazyQuery>;